import { Directory, FileNode } from "../filesystem";

export function findPath(current: Directory, path: string[]): Directory | null {
    let dir = current;
    for (const segment of path) {
        const child = dir.children.find(n => n.type === "directory" && n.name === segment) as Directory | undefined;
        if (!child) return null;
        dir = child;
    }
    return dir;
}